export const SUBSCRIPTION_REQUIRED_MESSAGE = "A paid subscription is required to make changes.";
export const SUBSCRIPTION_RECORDS_EXPIRED_MESSAGE = "Viewing and export access is unavailable. Billing recovery is still available.";

export async function subscriptionRequiredMessage(response: Response): Promise<string | null> {
  if (response.status !== 402) return null;
  try {
    const body = await response.clone().json() as { code?: string };
    return body.code === "subscription_required" ? SUBSCRIPTION_REQUIRED_MESSAGE
      : body.code === "subscription_records_expired" ? SUBSCRIPTION_RECORDS_EXPIRED_MESSAGE : null;
  } catch {
    return null;
  }
}
